<h1>Please log-in</h1>

<div id="container">
    <div id="firebaseui-auth-container" *ngIf="firebaseuiShow"></div>
    
    <div 
        id="check-popup"
        *ngIf="spinnerOn"
    >
        <mat-spinner 
            id="spinner"
            color="accent"
            diameter="40"
            (click)="reloadPage()"
        />
        <span *ngIf="checkGoogle">Please check Google popup.</span>
    </div>
</div>